import { Size } from '../model/Size'

export function calculateActualSize(screen: Size, resolution: Size): Size {
  const screenRatio = screen.height / screen.width
  const gameRatio = resolution.height / resolution.width
  if (screenRatio > gameRatio) {
    // 如果屏幕更高，按寬度縮放
    return {
      width: screen.width,
      height: screen.width * gameRatio,
    }
  }
  else {
    // 如果屏幕更寬，按高度縮放
    return {
      width: screen.height / gameRatio,
      height: screen.height,
    }
  }
}
